<template>
  <div id="course-outline-registration">
    <component
      :is="layout"
    />
  </div>
</template>

<script>
import { state } from "./data";
import { loadData } from "./data/data-loader";
import { initActions } from "./actions";

export default {
  components: {
    "layout-default": () => import("./layout-default.vue"),
  },
  computed: {
    layout() {
      return "layout-default";
    },
    state() {
      return state;
    }
  },
  methods: {
    async loadData() {
      // Defined this for make it accessable via this root component; (work like using 'this' keyword, except root is here);
      await loadData();
      this.$forceUpdate();
    }
  },
  beforeCreate() {
    this._name = "course-outline-registration";
  },
  created() {
    initActions(this);
    this.loadData();
  }
}
</script>
